// AF-3.19 P0 — fabricated/seeded-data remediation (Option B: explicit
// notice rather than silent display). Placed at the top of legacy pages
// the AF-3.19 audit confirmed have no real backend data path (AI Traffic,
// Discovery-to-Revenue) or a seeded-mock-then-persisted one (SEO,
// Creative Intelligence's scoring view). This is a pure frontend addition
// — no backend route was added or changed to produce this notice.

import { Warning } from '@phosphor-icons/react';

export function FabricatedDataNotice({ reason }) {
  return (
    <div
      data-testid="fabricated-data-notice"
      className="flex items-start gap-2.5 rounded-lg border border-[var(--warning-border)] bg-[var(--warning-bg)] px-4 py-3 mb-4"
    >
      <Warning size={16} className="text-[var(--warning)] mt-0.5 shrink-0" />
      <div>
        <p className="text-[11px] font-semibold text-[var(--warning)] uppercase tracking-wide mb-0.5">Example data — not live measurement</p>
        <p className="text-[11px] text-[var(--text-secondary)]">
          {reason || 'This page has no connected real data source yet. Numbers shown are illustrative, not a measurement of this brand.'}
        </p>
      </div>
    </div>
  );
}
